import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const ExtendIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="32" height="17" viewBox="0 0 32 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g id="smallIcon" clipPath="url(#clip0_988_8804)">
        <path
          id="Vector 427"
          d="M19 8.38281H28M28 8.38281L25 5.38281M28 8.38281L25 11.3828"
          stroke={fillColor || '#6C6C6C'}
          strokeLinejoin="round"
        />
        <path
          id="Vector 428"
          d="M19.5 8.38281H15.5V9.88281C15.5 10.4351 15.0523 10.8828 14.5 10.8828V10.8828C13.9477 10.8828 13.5 10.4351 13.5 9.88281V3.88281C13.5 3.33053 13.0523 2.88281 12.5 2.88281V2.88281C11.9477 2.88281 11.5 3.33053 11.5 3.88281V12.8828C11.5 13.4351 11.0523 13.8828 10.5 13.8828V13.8828C9.94772 13.8828 9.5 13.4351 9.5 12.8828V1.88281C9.5 1.33053 9.05228 0.882812 8.5 0.882812V0.882812C7.94772 0.882812 7.5 1.33053 7.5 1.88281V10.8828C7.5 11.4351 7.05228 11.8828 6.5 11.8828V11.8828C5.94772 11.8828 5.5 11.4351 5.5 10.8828V5.88281C5.5 5.33053 5.05228 4.88281 4.5 4.88281V4.88281C3.94772 4.88281 3.5 5.33053 3.5 5.88281V8.38281H2"
          stroke={fillColor || '#6C6C6C'}
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_988_8804">
          <rect width="32" height="16" fill={fillColor || 'white'} transform="translate(0 0.382812)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export { ExtendIcon };
